import { useMutation, useQueryClient } from '@tanstack/react-query'
import { submitAssessment } from 'api/user/assessments/submitAssessment'
import { WorkerRequirementEvaluationStatus } from 'api/user/assessments/typings'
import { assessmentsKeys } from './keys'

export type UseSubmitAssessmentData = Record<
  number,
  {
    workerRequirementId: number
    status: WorkerRequirementEvaluationStatus
  }
>

export type SubmitAssessmentsPayload = {
  assessments: UseSubmitAssessmentData
  evaluationNote?: string | null
}

/**
 * Pass or fail an assessment skill for a user; optionally include general feedback.
 */
export function useSubmitAssessments({
  userId,
  shiftId,
  externalCandidateId,
}: {
  userId: number
  shiftId: number
  externalCandidateId: string
}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ assessments, evaluationNote }: SubmitAssessmentsPayload) =>
      submitAssessment({
        userId,
        externalCandidateId,
        assessments: Object.values(assessments),
        evaluationNote,
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: assessmentsKeys.byShiftId(shiftId),
      }),
  })
}
